import Vue from 'vue'
import Router from 'vue-router'
import ImportHelper from '@/utils/chunkImportWrapper'

import Cart from '@/components/modules/checkout/Cart'
import CartScreen from '@/components/modules/hosted-pages/CartScreen'
import CartNew from '@/components/modules/checkout/CartNew'
import ThankyouComponent from '@/components/modules/hosted-pages/ThankyouComponent'
import ChoosePaymentMethod from '@/components/modules/hosted-pages/ChoosePaymentMethod'
import HostedPage from '@/components/modules/hosted-pages/HostedPage'
import Checkout from '@/components/modules/hosted-pages/Checkout'
import ErrorComponent from '@/components/modules/hosted-pages/ErrorComponent/'
import store from "@/store/checkout"
import OneScreenReview from "@/components/modules/hosted-pages/OneScreenReview"
import GocardlessGuarantee from "@/components/modules/hosted-pages/payment-methods/direct-debit/GocardlessGuarantee"

//dynamic imports - use prefix 'checkout' for webpackChunkName - to avoid name collision
const FormMixin = ImportHelper.wrapImport(() => import(/* webpackChunkName: "checkout-form-mixin" */"@/mixins/form-mixin"))
const CheckUserScreen = ImportHelper.wrapImport(() => import(/* webpackChunkName: "checkout-check-user" */'@/components/modules/hosted-pages/CheckUserScreen'))
const OtpAuthentication = ImportHelper.wrapImport(() => import(/* webpackChunkName: "checkout-check-user" */'@/components/modules/hosted-pages/OtpAuthentication'))
const FinalReview = ImportHelper.wrapImport(() => import(/* webpackChunkName: "checkout-final-review" */"@/components/modules/checkout/FinalReview"))
const AccountSection = ImportHelper.wrapImport(() => import(/* webpackChunkName: "checkout-account-section" */"@/components/modules/checkout/AccountSection"))
const BillingAndShippingSection = ImportHelper.wrapImport(() => import(/* webpackChunkName: "checkout-billing-shipping" */"@/components/modules/checkout/BillingAndShippingSection"))
const PaymentSection = ImportHelper.wrapImport(() => import(/* webpackChunkName: "checkout-payment-section" */"@/components/modules/checkout/PaymentSection"))
const SubscriptionSection = ImportHelper.wrapImport(() => import(/* webpackChunkName: "checkout-subscription-section" */"@/components/modules/checkout/SubscriptionSection"))
const InvoiceSection = ImportHelper.wrapImport(() => import(/* webpackChunkName: "checkout-invoice-section" */"@/components/modules/checkout/InvoiceSection"))
const GiftDetailsSection = ImportHelper.wrapImport(() => import(/* webpackChunkName: "checkout-gift-details-section" */"@/components/modules/checkout/GiftDetailsSection"))
const EstimateDisplayScreen = ImportHelper.wrapImport(() => import(/* webpackChunkName: "checkout-estimate-disp-screen" */"@/components/modules/hosted-pages/EstimateDisplayScreen"))
const UpiTimer = ImportHelper.wrapImport(() => import(/* webpackChunkName: "checkout-upi-timer-screen" */"@/components/modules/hosted-pages/payment-methods/UpiTimer"))
const VoucherDetail = ImportHelper.wrapImport(() => import(/* webpackChunkName: "checkout-view-voucher-screen" */"@/components/modules/hosted-pages/VoucherDetail"))
const PaymentLoader = ImportHelper.wrapImport(() => import(/* webpackChunkName: "checkout-awaiting-for-confirmation-screen" */"@/components/modules/hosted-pages/payment-methods/PaymentLoader"))


var setCurrentStep = (name) => {
  if(store.getters.current_checkout_step != name) {
    store.commit("SET_CURRENT_STEP", name);
  }
}

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/pages/v3/:token',
      component: HostedPage,
      children: [
        {
          path: 'authenticate',
          component: OtpAuthentication,
          name: "authenticate",
          meta: {
            userHasPassword: (route) =>{
              return route.query.userHasPassword;
            },
            "header": "header-1", "headerTitle":"cart.header", "isHeaderTitle":true, "headerLogo":true, "gaKey": "otp_authentication"
          }
        },
        {
          path: 'check_user',
          component: CheckUserScreen,
          name: "check_user",
          meta: {"header": "header-1", "headerTitle":"cart.header", "isHeaderTitle":true, "headerLogo":true, "gaKey": "check_user_screen"}
        },
        {
          path: "cart",
          component: Cart,
          name: "cart",
          meta: {"header": "header-1", "headerTitle":"cart.header", "isHeaderTitle":true, "headerLogo":true}
        },
        {
          path: "cart_new",
          component: CartNew,
          name: "cart_new",
          meta: {"header": "header-1", "headerTitle":"cart.header", "isHeaderTitle":true, "headerLogo":true}
        },
        {
          path: "cart_screen",
          component: CartScreen,
          name: "cart_screen",
          meta: {"header": "header-1", "headerTitle":"cart.header", "isHeaderTitle":true, "headerLogo":true, "gaKey": "cart_screen"}
        },
        {
          path: "checkout",
          component: Checkout,
          name: "checkout",
          children: [
            {
              path: "account",
              component: AccountSection,
              name: "customer",
              meta: {
                headerType: (route) => {
                  return route.query.mode == "edit" ? "header-2" : "header-1" ;
                },
                "showCheckoutSteps":true,
                "isHeaderTitle":true,
                "gaKey": (route) => {
                  return route.query.mode == "edit" ? "edit_account_info" : "add_account_info" ;
                }
              },
              beforeEnter: (to, from, next) => {
                let queryMode = to.query.mode == "edit";
                !queryMode && setCurrentStep(to.name);
                next();
              }
            },
            {
              path: "billing_address",
              component: BillingAndShippingSection,
              name: "billing_address",
              meta: {
                headerType: (route) => {
                  return route.query.mode == "edit" ? "header-2" : "header-1" ;
                },
                "showCheckoutSteps":true,
                "isHeaderTitle":true,
                "gaKey": (route) => {
                  return route.query.mode == "edit" ? "edit_billing_address" : "add_billing_address" ;
                }
              },
              beforeEnter: (to, from, next) => {
                let queryMode = to.query.mode == "edit";
                !queryMode && setCurrentStep(to.name);
                next();
              }
            },
            {
              path: "shipping_address",
              component: BillingAndShippingSection,
              name: "shipping_address",
              meta: {
                headerType: (route) => {
                  return (route.query.mode == "edit" || route.query.mode == "empty") ?
                    "header-2" : "header-1";
                },
                "showCheckoutSteps":true,
                "isHeaderTitle":true,
                "gaKey": (route) => {
                  return route.query.mode == "edit" ? "edit_shipping_address" : "edit_shipping_address" ;
                }
              },
              beforeEnter: (to, from, next) => {
                // TODO Dry this
                let queryMode = to.query.mode == "edit" || to.query.mode == "empty";
                !queryMode && setCurrentStep(to.name);
                next();
              }
            },
            {
              path: "payment_method",
              component: PaymentSection,
              name: "payment_method",
              meta: {
                headerType: (route) => {
                  return (route.query.mode == "edit" || route.query.mode == "empty") ?
                    "header-2" : "header-1";
                },
                "showCheckoutSteps":true,
                "isHeaderTitle":true,
                "gaKey": (route) => {
                  return route.query.mode == "edit" ? "edit_payment_method" : "add_payment_method" ;
                }
              },
              beforeEnter: (to, from, next) => {
                // TODO Dry this
                let queryMode = to.query.mode == "edit" || to.query.mode == "empty";
                !queryMode && setCurrentStep(to.name);
                next();
              }
            },
            {
              path: "gift_details",
              component: GiftDetailsSection,
              name: "gift_details",
              meta: {
                headerType: (route) => {
                  return (route.query.mode == "edit" || route.query.mode == "empty") ?
                    "header-2" : "header-1";
                },
                "showCheckoutSteps":true,
                "isHeaderTitle":true,
                "gaKey": (route) => {
                  return route.query.mode == "edit" ? "edit_gift_details" : "add_gift_details" ;
                }
              },
              beforeEnter: (to, from, next) => {
                // TODO Dry this
                let queryMode = to.query.mode == "edit" || to.query.mode == "empty";
                !queryMode && setCurrentStep(to.name);
                next();
              }

            },
            {
              path: "subscription_cf",
              component: SubscriptionSection,
              name: "subscription",
              meta: {
                headerType: (route) => {
                  return (route.query.mode == "edit" || route.query.mode == "empty") ?
                    "header-2" : "header-1";
                },
                "showCheckoutSteps":true,
                "isHeaderTitle":true,
                "gaKey": (route) => {
                  return route.query.mode == "edit" ? "edit_subscription_cf_info" : "add_subscription_cf_info" ;
                }
              },
              beforeEnter: (to, from, next) => {
                let queryMode = to.query.mode == "edit" || to.query.mode == "empty";
                !queryMode && setCurrentStep(to.name);
                next();
              }
            },
            {
              path: "invoice_cf",
              component: InvoiceSection,
              name: "invoice",
              meta: {
                headerType: (route) => {
                  return (route.query.mode == "edit" || route.query.mode == "empty") ?
                    "header-2" : "header-1";
                },
                "showCheckoutSteps":true,
                "isHeaderTitle":true,
                "gaKey": (route) => {
                  return route.query.mode == "edit" ? "edit_invoice_cf_info" : "add_invoice_cf_info";
                }
              },
              beforeEnter: (to, from, next) => {
                let queryMode = to.query.mode == "edit" || to.query.mode == "empty";
                !queryMode && setCurrentStep(to.name);
                next();
              }
            },
            {
              path: "review",
              component: FinalReview,
              name: "review",
              meta: {"header": "header-1", "headerLogo":true, "showCheckoutSteps":false, "isHeaderTitle":true, "gaKey": "review_screen"},
              beforeEnter: (to, from, next) => {
                setCurrentStep(to.name);
                if(store.getters.one_screen_checkout) {
                  next({name: "pay_review", params: to.params, replace: true});
                }
                next();
              },
            },
            {
              path: "pay",
              component: OneScreenReview,
              name: "pay_review",
              meta: {"header": "header-1", "headerLogo":true, "showCheckoutSteps":false, "isHeaderTitle":true, "gaKey": "review_screen"},
              beforeEnter: (to, from, next) => {
                setCurrentStep("review");
                if(!store.getters.one_screen_checkout) {
                  next({name: "review", params: to.params, replace: true});
                }
                next();
              },
            }
          ]
        },
        {
          path: "thankyou",
          component: ThankyouComponent,
          name: "thankyou",
          meta: {"header": "header-thankyou", "headerLogo": true, "gaKey": "thankyou_screen", isHeaderTitle: false},
        },
        {
          path: "voucher",
          component: VoucherDetail,
          name: "voucher",
          meta: {"header": "header-1", "headerTitle":"cart.header", "isHeaderTitle":true, "headerLogo":true,  "gaKey": "voucher_thankyou_screen"},
        },
        {
          path: "upi_timer",
          component: UpiTimer,
          name: "upi_timer",
          meta: {"header": "header-1", "headerTitle":"upi_loader.header",  commonTranslate: true, "isHeaderTitle":true, "headerLogo":true, "gaKey": "upi_timer_screen"}
        },
        {
          path: "awaiting_for_confirmation",
          component: PaymentLoader,
          name: "awaiting_for_confirmation",
          meta: {"header": "header-1", "headerTitle":"payment_loader.header",  commonTranslate: true, "isHeaderTitle":true, "headerLogo":true, "gaKey": "awaiting_for_confirmation_screen"}
        },
        {
          path: "choose_payment_method",
          component: ChoosePaymentMethod,
          name: "choose_pm",
          meta: {
            // Show header with back button for edit mode or else show common header.
            headerType: (route) => {
              return (route.query.mode == "edit" || route.query.mode == "empty") ?
                "header-2" : "header-1";
            }
            , headerTitle: "choose_pm.header", "isHeaderTitle":true, "gaKey": "choose_pm_screen" }
        },
        {
          path: "guarantee",
          component: GocardlessGuarantee,
          name: "checkout_gocardless_guarantee",
          meta: { header: "header-2", headerTitle: "payment_method.bacs.guarantee.header", "isHeaderTitle":true, "gaKey": "guarantee_screen" },
        },
        {
          path: "edit_order",
          component: Cart,
          name: "edit_order",
          meta: {"header": "header-2", headerTitle: "cart.header.edit" , "isHeaderTitle":true, "gaKey": "edit_order_screen"}
        },
        {
          path: "edit_cart_new",
          component: CartNew,
          name: "edit_cart_new",
          meta: {"header": "header-2", headerTitle: "cart.header.edit" , "isHeaderTitle":true, "gaKey": "edit_order_screen"}
        },
        {
          path: "estimate_display_screen",
          component: EstimateDisplayScreen,
          name: "estimate_display_screen",
          meta: {"header": "header-2", headerTitle: "estimate_display_screen.header" , "isHeaderTitle":true, "gaKey": "estimate_display_screen"}
        }
      ]
    },
    {
      path: '/pages/v3/:token/error',
      component: ErrorComponent,
      name: "error"
    },
    {
      path: '/pages/v3/:token/*',
      redirect: {name: 'error'}
    }
  ]
})
